<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h3>{{getType( this.$route.params.typeAbbr).report_name}}</h3>
      </v-flex>
      <v-flex xs12>
        <div
                v-if="isManager"
        >
          <v-menu
                  v-for="([caption, path], index) in btns"
                  :key="index"
                  offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                      :to="path"
              >
                {{ caption }}
              </v-btn>
            </template>
          </v-menu>
        </div>
      </v-flex>
      <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      btns: [
        ['Отчеты',
          {
            name: 'reporting_list',
            params: {
              typeAbbr: this.$route.params.typeAbbr
            }
          }
        ],
        ['Привязка организаций',
          {
            name: 'reporting_report_type_department_list',
            params: {
              typeAbbr: this.$route.params.typeAbbr
            }
          }
        ]
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters['auth/user']
    },
    isManager () {
      return this.user.groups.includes(this.getType(this.$route.params.typeAbbr).manager_group)
    }
  },
  methods: {
    getType (typeAbbr) {
      return this.$store.getters['reportingReport/getType'](typeAbbr)
    }
  },
  created: function () {
    this.$store.dispatch('reportingReport/fetchStatuses')
    this.$store.dispatch('reportingReport/fetchTypes')
  }
}
</script>
<style>

</style>
